import React from "react";

import * as styles from "./pageContainer.module.css";

function PageContainer({ children }) {
  return <div className={styles.container}>{children}</div>;
}

export default PageContainer;
